import type { ButtonHTMLAttributes, ReactNode } from 'react';

import { cn } from '../lib/cn';

interface IChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  readOnly?: boolean;
  onClear?: () => void;
  /** What the × says to a screen reader; a chip is not always a filter. */
  clearLabel?: string;
  children: ReactNode;
}

export const Chip = ({
  active,
  onClear,
  clearLabel = 'Remove this filter',
  readOnly,
  children,
  className,
  ...rest
}: IChipProps) => (
  <span
    className={cn(
      'inline-flex h-control-sm items-center rounded-control text-meta',
      active ? 'bg-chip-on text-primary' : 'bg-chip text-muted',
      className,
    )}
  >
    {readOnly ? (
      <span className="flex h-full items-center gap-2 px-flat">{children}</span>
    ) : (
      <button type="button" className="flex h-full items-center gap-2 px-flat" {...rest}>
        {children}
      </button>
    )}
    {onClear && (
      <button
        type="button"
        aria-label={clearLabel}
        onClick={onClear}
        className="flex h-full items-center pr-flat pl-1 text-faint hover:text-primary"
      >
        ×
      </button>
    )}
  </span>
);
